import React, { useState, useEffect } from "react";
import { Button } from "../../../../_helpers/components/Button";
import { useNavigate, useParams } from "react-router-dom";
import { InputForm } from "../../../../_helpers/components/Forms/InputLabel";
import { Toggle } from "../../../../_helpers/components/Forms/ToggleButton";
import {
    createEstablishment,
    updateEstablishment,
    getEstablishment,
} from "../../../../_api/Establishment";
import toast from "react-hot-toast";

const AddEstablishment = () => {
    const navigate = useNavigate();

    const { establishment_id } = useParams();
    const [name, setName] = useState("");
    const [createdDate, setCreation] = useState({
        startDate: null,
        endDate: null,
    });
    const [address, setAddress] = useState("");
    const [enabled, setEnabled] = useState(false);

    const [collectives, setCollectives] = useState([]);
    const [selectValue, setSelectValue] = useState("");
    const [isActiveSelect2, setIsActiveSelect] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (establishment_id) {
            getEstablishment(establishment_id).then((resp) => {
                setName(resp.data.name);
                setCreation({
                    startDate: new Date(resp.data.establishment_creation),
                    endDate: new Date(resp.data.establishment_creation),
                });
                setAddress(resp.data.address);
                setEnabled(resp.data.status === "ACTIVE" ? true : false);
            });
        }
    }, [establishment_id]);

    const addEstablishment = () => {
        const payload = {
            name,
            address,
            establishment_creation: createdDate,
            status: enabled ? "ACTIVE" : "ARCHIVED",
            collectives: collectives,
        };
        setIsSaving(true);
        const request = establishment_id
            ? updateEstablishment(establishment_id, payload)
            : createEstablishment(payload);
        request
            .then(() => {
                toast(establishment_id ? "Votre établissement a été modifié." : "L'établissement a été ajouté.");
                navigate("/company/informations");
            })
            .finally(() => setIsSaving(false));
    };

    return (
        <>
            <h5 className="text-app-primary text-2xl">
                {establishment_id ? "Modifier" : "Ajouter"} un établissement
            </h5>
            <div>
                <InputForm
                    name="Nom"
                    value={name}
                    placeholder="Nom"
                    type="text"
                    set={setName}
                    required={true}
                />
                <InputForm
                    name="Adresse"
                    value={address}
                    placeholder="Addresse"
                    type="text"
                    set={setAddress}
                    required={true}
                />
                <InputForm
                    name="Date de création"
                    value={createdDate}
                    type="date"
                    required={true}
                    set={setCreation}
                />
                {establishment_id && (
                    <Toggle
                        enabled={enabled}
                        setEnabled={setEnabled}
                        name={"Archivé ?"}
                    />
                )}

                <Button
                    action={() => {
                        addEstablishment();
                    }}
                    name={"Enregistrer"}
                    loading={isSaving}
                />
            </div>
        </>
    );
};

export default AddEstablishment;
